'use strict';
var food = {
    Drink: {
        Wine: {},
        Schnaps: {}
    },
    Fruit: {
        Red: {
            Cherry: {},
            Strawberry: {}
        },
        Yellow: {
            Banana: {},
            Pineapple: {}
        }
    }
};
var tree = document.querySelector('#tree');
function createTree(element, data) {
    if (Object.keys(data).length === 0) return;
    var ourUl = document.createElement('ul');
    for(var key in data){
        var ourLi = document.createElement('li');
        ourLi.textContent = key;
        createTree(ourLi, data[key]);
        ourUl.append(ourLi);
    }
    element.append(ourUl);
}
createTree(tree, food);

//# sourceMappingURL=js_tree-from-object-DOM.36163d1f.js.map
